module.exports = __webpack_public_path__ + "static/media/Sau.2baef327.mp3";